import { combineReducers } from 'redux';

import configuration from 'reducers/configuration';
import user from 'reducers/user';
import translate from 'reducers/translate';
import player from 'reducers/player';
import movie from 'reducers/movie';
import ad from 'reducers/ad';
import season from 'reducers/season';
import episode from 'reducers/episode';
import login from 'reducers/login';
import registration from 'reducers/registration';
import restore from 'reducers/restore';
import subscription from 'reducers/subscription';
import videoCollection from 'reducers/videoCollection';
import app from 'reducers/app';
import billing from 'reducers/billing';
import userAgent from './userAgent';

const rootReducer = combineReducers({
  configuration,
  user,
  translate,
  player,
  movie,
  ad,
  season,
  episode,
  login,
  registration,
  restore,
  subscription,
  videoCollection,
  app,
  billing,
  userAgent,
});

export default rootReducer;
